import * as React from 'react';
import { Modal, ModalBody, ModalHeader } from '../Bootstrap';
import { CloseIcon } from '../CloseIcon';
import './NobleModal.scss';

interface NobleModalProps {
  isOpen: boolean;
  children: any;
  size?: string;
  className?: string;
  hideCloseIcon?: boolean;
  toggle();
}

const Title = ({ title }: { title: string }) => {
  return <ModalHeader className='justify-content-center'>{title}</ModalHeader>;
};

type INobleModal = React.FC<React.PropsWithChildren<NobleModalProps>> & {
  Title: typeof Title;
  Body: typeof ModalBody;
};

export const NobleModal: INobleModal = (props) => {
  return (
    <Modal size={props.size} className={`noble-modal ${props.className}`} isOpen={props.isOpen} toggle={props.toggle}>
      {!props.hideCloseIcon && <CloseIcon onClick={props.toggle} className='noble-modal-close' />}
      {props.children}
    </Modal>
  );
};

NobleModal.Title = Title;
NobleModal.Body = ModalBody;
